// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ArticleSearch":"bax_a bht_ea bht_sn","ArticleSearch__items":"bax_b bht_tg","ArticleSearch__item":"bax_c bht_th"};